import { ScoreData } from '../PartnerScoreDataAvailabilityTypes/PartnerScoreDataAvailabilitytypes';

interface Country {
  label: string;
  value: string;
}

export const useDisplayedCountries = (
  userCountries: Country[],
  sortedUserCountries: Country[],
  filteredPartnerScore: ScoreData[],
  displayCount: number,
): Country[] => {
  if (filteredPartnerScore.length > 0) {
    const countriesInFilteredScore = new Set(filteredPartnerScore.map(score => score.country));
    return userCountries.filter(country => countriesInFilteredScore.has(country.value));
  }
  return sortedUserCountries.slice(0, displayCount);
};
